import React from 'react'
import {Button, Dropdown} from "antd"
import ClubMemberFindDiamond from "./component/ClubMemberFindDiamond"
import ClubMemberFindLevel from "./component/ClubMemberFindLevel"
import ClubMemberFindTrack from "./component/ClubMemberFindTrack/ClubMemberFindTrack"
import ClubMemberFindWallet from "./component/ClubMemberFindWallet"
import {BarsOutlined} from "@ant-design/icons"

const ClubMemberFind = ({member}) => {
    const items = [
        {
            key: '1',
            label: (
                <ClubMemberFindWallet memberId={member.id}/>

            ),
        },
        {
            key: '2',
            label: (
                <ClubMemberFindDiamond memberId={member.id}/>

            ),
        },
        {
            key: '3',
            label: (
                <ClubMemberFindLevel memberId={member.id}/>

            ),
        },
        {
            key: '4',
            label: (
                <ClubMemberFindTrack memberId={member.id}/>
            )
        }
    ]

    return (<div>
        <Dropdown menu={{items}} arrow>
            <Button type={"primary"} icon={<BarsOutlined />}>查看</Button>
        </Dropdown>
    </div>)
}

export default ClubMemberFind


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/ClubMemberFind.js